import React from 'react';

/**
 * Illustration of the back cover of a book with the ISBN barcode
 * highlighted, so new sellers know what to point the camera at.
 * Pure SVG – no image assets needed.
 */
const BarcodeExample: React.FC<{ className?: string }> = ({ className = '' }) => {
  // EAN-13 style bar pattern (widths alternate bar/space), purely decorative
  const bars = [1, 1, 1, 2, 1, 2, 1, 1, 3, 1, 1, 2, 2, 1, 1, 1, 2, 1, 3, 1, 1, 1, 2, 2, 1, 1, 1, 3, 1, 1, 2, 1, 1, 2, 1, 1, 1, 2, 1, 3, 1, 1, 2, 1, 1, 1, 1, 2, 1, 1, 3, 1, 1, 1, 1];
  let x = 0;
  const rects: React.ReactNode[] = [];
  bars.forEach((w, i) => {
    if (i % 2 === 0) {
      rects.push(<rect key={i} x={x} y={0} width={w} height={26} fill="#232323" />);
    }
    x += w;
  });
  const barsWidth = x;

  return (
    <svg viewBox="0 0 240 180" className={className} role="img" aria-label="Back cover of a book showing where the ISBN barcode is">
      <defs>
        <linearGradient id="bce-cover" x1="0" x2="1">
          <stop offset="0" stopColor="#F7F1E5" />
          <stop offset="1" stopColor="#EFE6D3" />
        </linearGradient>
      </defs>
      {/* Shadow + back cover */}
      <rect x="34" y="12" width="176" height="160" rx="4" fill="#000" opacity="0.08" />
      <rect x="30" y="8" width="176" height="160" rx="4" fill="url(#bce-cover)" stroke="#D9CDB4" />
      {/* Spine */}
      <rect x="30" y="8" width="8" height="160" rx="2" fill="#C9B995" />
      {/* Blurb lines */}
      {[24, 32, 40, 48, 60, 68, 76].map((y, i) => (
        <rect key={y} x="50" y={y} width={i === 3 ? 80 : i === 6 ? 60 : 140} height="4" rx="2" fill="#C8BDA5" />
      ))}
      {/* Barcode box */}
      <rect x="112" y="98" width="86" height="60" rx="2" fill="#FFFFFF" stroke="#D9CDB4" />
      <text x="117" y="110" fontSize="7" fontFamily="ui-sans-serif, system-ui, sans-serif" fill="#232323">ISBN 978-0-000-00000-0</text>
      <g transform={`translate(${117 + (76 - barsWidth) / 2}, 114)`}>{rects}</g>
      <text x="155" y="152" fontSize="7" textAnchor="middle" fontFamily="ui-monospace, monospace" fill="#232323">9 780000 000000</text>
      {/* Highlight frame + label */}
      <rect x="106" y="92" width="98" height="72" rx="6" fill="none" stroke="#EB2D40" strokeWidth="3" strokeDasharray="10 5" />
      <path d="M92 132 L104 128" stroke="#EB2D40" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M100 124 L104 128 L99 131" fill="none" stroke="#EB2D40" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="40" y="122" width="52" height="18" rx="9" fill="#EB2D40" />
      <text x="66" y="134" fontSize="9" fontWeight="700" textAnchor="middle" fontFamily="ui-sans-serif, system-ui, sans-serif" fill="#FFFFFF">Scan this</text>
    </svg>
  );
};

export default BarcodeExample;
